import isEmpty from 'lodash/isEmpty';

import { TaskParents } from '../shared/models/parents.model';
import { Task, TaskStatusItem } from '../shared/models/deprecated-task.model';
import { TaskStatus } from '../shared/enums/deprecated-task.enum';

export function getStatusItem(status: TaskStatus): TaskStatusItem {
  const display = getTaskStatusDisplay(status);
  return {
    className: display.toLowerCase().replace(' ', '-'),
    display,
    value: status,
    isComplete: status === TaskStatus.Complete,
  };
}

export function getTaskStatusDisplay(status: TaskStatus): string {
  return status === TaskStatus.Complete ? 'Completed' : status === TaskStatus.InProgress ? 'In Progress' : 'To Do';
}

export function getTaskParentLabels(task: Task): TaskParents {
  if (isEmpty(task?.parent_info)) {
    return {} as TaskParents;
  }
  const parentLabels = {} as TaskParents;
  for (const [k, v] of Object.entries(task.parent_info)) {
    parentLabels[k] = v?.[k === 'file' ? 'name' : 'label'];
  }
  return parentLabels;
}

export function getHierarchyDisplay(labels: Record<string, string>, parentLabels: TaskParents): string {
  return [
    `${labels.group}: ${parentLabels.group}`,
    `${labels.project}: ${parentLabels.project}`,
    parentLabels.subject && `${labels.subject}: ${parentLabels.subject}`,
    parentLabels.session && `${labels.session}: ${parentLabels.session}`,
    parentLabels.acquisition && `${labels.acquisition}: ${parentLabels.acquisition}`,
    parentLabels.file && `${labels.file}: ${parentLabels.file}`,
  ].filter((v) => Boolean(v)).join('\n');
}
